import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex w-min" }
const _hoisted_2 = ["onClick"]

import InputField from './InputField.vue';
import { computed, PropType, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  modelValue: {
    type: [String, Number],
    required: true,
  },
  title: {
    type: String,
    default: null,
  },
  items: {
    type: Array as PropType<
      Array<{ value?: string | number; text: string; clickable: boolean }>
    >,
    default: () => [],
  },
  type: {
    type: String,
    default: 'yes/no',
  },
  hint: {
    type: String,
    default: null,
  },
  disabled: {
    type: Boolean,
  },
  status: {
    type: String,
  },
  informationText: {
    type: String,
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {





const baseClass = ref(
  'flex justify-center items-center flex-grow toggle-item border border-primary sm:w-20 text-center text-xs px-3 py-2 select-none'
);

const selectableClass = ref('hover:bg-primary cursor-pointer hover:text-white');

const selectedClass = computed(
  () => `${baseClass.value} bg-primary text-white`
);

const unselectedClass = computed(() => baseClass.value);

function onUpdate(value: {
  value?: string | number;
  text: string;
  clickable: boolean;
}) {
  emit('update:modelValue', value.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InputField, _mergeProps(_ctx.$attrs, {
    hint: __props.hint,
    title: __props.title
  }), _createSlots({
    status: _withCtx(() => [
      _createTextVNode(_toDisplayString(__props.status), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: item.value
          }, [
            (!item.clickable)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass([baseClass.value, 'bg-secondary border-secondary text-white'])
                }, _toDisplayString(item.text), 3))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass([
              baseClass.value,
              selectableClass.value,
              {
                [_unref(selectedClass)]: __props.modelValue === item.value,
                [_unref(unselectedClass)]: __props.modelValue !== item.value,
                'pointer-events-none': __props.disabled,
              },
            ]),
                  onClick: ($event: any) => (onUpdate(item))
                }, _toDisplayString(item.text), 11, _hoisted_2))
          ], 64))
        }), 128))
      ])
    ]),
    _: 2
  }, [
    (__props.informationText)
      ? {
          name: "notes",
          fn: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.informationText), 1)
          ])
        }
      : undefined
  ]), 1040, ["hint", "title"]))
}
}

})